import { EVENT_STARTED_KEY, NAMESPACE } from "../operations/constants";

const emitStartedEvent = async ({ eventBus, operationName, args }) => {
  await new Promise(resolve => setTimeout(resolve));

  eventBus.emit(`${NAMESPACE}.${operationName}:${EVENT_STARTED_KEY}`, ...args);
};

export default emitStartedEvent;
